import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CfUserProfileStackComponent, ICFUser } from '../cf-user-profile-stack/cf-user-profile-stack.component';
import { CfProfileComponent } from '../cf-profile/cf-profile.component';

@Component({
    selector: 'app-cf-text-review',
    templateUrl: './cf-text-review.component.html',
    styleUrls: ['./cf-text-review.component.scss'],
    imports: [CommonModule, CfUserProfileStackComponent]
})
export class CfTextReviewComponent implements OnInit, OnChanges {
    @Input() reviewItem!: CFTextReviewItem;
    @Input() readOnly = false;
    @Input() classOverride = '';
    @Output() statusChanged: EventEmitter<CFTextReviewItem> = new EventEmitter();

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    changeStatus(event: Event): void {
        if (this.readOnly) return;

        // We go directly to concern, no feedback anymore.
        switch (this.reviewItem.status) {
            case CFTextReviewStatus.None:
                this.reviewItem.status = CFTextReviewStatus.Concern;
                break;
            // case CFTextReviewStatus.Feedback:
            //     this.reviewItem.status = CFTextReviewStatus.Concern;
            //     break;
            case CFTextReviewStatus.Concern:
                this.reviewItem.status = CFTextReviewStatus.None;
                break;
        }

        this.statusChanged.emit(this.reviewItem);

        event.stopImmediatePropagation();
    }
}

export interface ICFTextReviewItem {
    status: CFTextReviewStatus;     // status for display
    dataItem: string;               // may need to be bigger
    text: string;                   // actual text - need a heading?
    category: string;
    subCategory: string;
    target: CFTextReviewTarget;
    reviewingUsers: ICFUser[];      // history
    reviewerNote?: string;
}

export enum CFTextReviewStatus {
    None = '',
    Feedback = 'todo',
    Concern = 'warn'
}

export enum CFTextReviewTarget {
    Applicant = 0,
    Interviewer = 1,
    Safeguarding,
}

export class CFTextReviewItem implements ICFTextReviewItem {
    dataItem: string;
    heading?: string;
    text: string;
    status: CFTextReviewStatus = CFTextReviewStatus.None;
    category: string;
    subCategory: string;
    target: CFTextReviewTarget = CFTextReviewTarget.Applicant;
    reviewingUsers: ICFUser[] = [];
    reviewerNote?: string;
    isValid = false;
    constructor(data: string, text: string, category?: string, subcategory?: string, target?: CFTextReviewTarget, status?: CFTextReviewStatus, users?: ICFUser[]) {
        this.dataItem = data;
        this.text = text;
        this.status = status ?? CFTextReviewStatus.None;
        this.reviewingUsers = users ?? [];
        this.target = target ?? CFTextReviewTarget.Applicant;
        this.category = category ?? '';
        this.subCategory = subcategory ?? '';
        this.isValid = this.status == CFTextReviewStatus.Feedback;
    }

    public static ApplicantItem(heading: string, data: string, text: string, category?: string, subCategory?: string): CFTextReviewItem {
        const h = new CFTextReviewItem(data, text, category, subCategory, CFTextReviewTarget.Applicant);
        h.heading = heading;
        return h;
    }

    public static InterviewerItem(heading: string | undefined, data: string, text: string, category?: string, subCategory?: string): CFTextReviewItem {
        const h = new CFTextReviewItem(data, text, category, subCategory, CFTextReviewTarget.Interviewer);
        if(heading) h.heading = heading;
        // console.log(`Added: ${JSON.stringify(h,null,2)}`);
        return h;
    }    

    public static SafeGuardingItem(heading: string, data: string, text: string, category?: string, subCategory?: string): CFTextReviewItem {
        const h = new CFTextReviewItem(data, text, category, subCategory, CFTextReviewTarget.Safeguarding);
        h.heading = heading;
        return h;
    }   
}